export default __webpack_public_path__ + "static/media/Rating.56d2479f.svg";